const base_URL = 'https://apidistrico.districom-ci.net/public';
const BackendRouteLink =  {
        station_create : '/station/create', 
        station_get : base_URL+'/station/get', 
        gaz_create : '/station/gaz/price/create', 
        gaz_get : base_URL+'/station/gaz/price/get', 
        gaz_delete : '/station/gaz/price/delete', 
        station_search : base_URL+'/stations/search', 
        newsletter_add : base_URL+'/newsletter/add', 
        newsletter_get : '/newsletter/get', 
        news_create : '/news/create', 
        news_get : base_URL+'/news/get', 
        job_create : '/job/create', 
        job_get :'/job/get', 
        job_public_get :base_URL+'/job/get', 
        conseil_get :base_URL+'/conseil/get', 
        conseil_create :'/conseil/create',
        conseil_delete :'/conseil/delete',
        conseil_postcomment :base_URL+'/conseil/post/comment',
        conseil_getcomment :base_URL+'/conseil/get/comment',
        conseil_getsimular :base_URL+'/conseil/get/simular',
        actualite_get :base_URL+'/actualite/get', 
        actualite_create :'/actualite/create',
        actualite_delete :'/actualite/delete',
        actualite_postcomment :base_URL+'/actualite/post/comment',
        actualite_getcomment :base_URL+'/actualite/get/comment',
        actualite_getsimular :base_URL+'/actualite/get/simular',
        application_sp :'/application/spontaneous/create',
        applicationsp_get :'/application/spontaneous/get',
        applicationoffer_create:'/application/offer/create',
        contactinfo:base_URL+'/contact/info',
}
export default BackendRouteLink;